module.exports = __webpack_public_path__ + "img/logo-vrjmof.99a6ddd8.svg";